import type {ConnectorDraft} from 'src/types/connector';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';
import {
  SET_CONNECTOR_ID,
  SET_ENDPOINT_ID,
  SET_RECIPIENT_ENTITY_ID_PATH,
  SET_VARIABLE_MAPPING,
  SET_SAMPLE_VALUE,
  SET_SAMPLE_PAYLOAD,
  RECEIVE_CONNECTOR,
  UPDATE_NODE_SCHEDULE,
  RESET,
  type ConnectorAction,
} from 'src/action-creators/connector';


const initialState: ConnectorDraft = {
  connectorId: null,
  endpointId: null,
  recipient_entity_id_path: null,
  variableMappings: {},
  sampleValues: {},
  samplePayload: '',
  ...getDefaultNodeScheduleState({}),
};

export default function connector(
  state: ConnectorDraft = initialState,
  action: ConnectorAction,
): ConnectorDraft {
  switch (action.type) {
    case SET_CONNECTOR_ID:
      if (state.connectorId === action.payload.connectorId) {
        return state;
      }
      // Switching connectors invalidates the prior endpoint selection.
      return {
        ...state,
        connectorId: action.payload.connectorId,
        endpointId: null,
      };
    case SET_ENDPOINT_ID:
      return {
        ...state,
        endpointId: action.payload.endpointId,
      };
    case SET_RECIPIENT_ENTITY_ID_PATH:
      return {
        ...state,
        recipient_entity_id_path: action.payload.recipientEntityIdPath,
      };
    case SET_VARIABLE_MAPPING:
      return {
        ...state,
        variableMappings: {
          ...state.variableMappings,
          [action.payload.key]: action.payload.value,
        },
      };
    case SET_SAMPLE_VALUE:
      return {
        ...state,
        sampleValues: {
          ...state.sampleValues,
          [action.payload.key]: action.payload.value,
        },
      };
    case SET_SAMPLE_PAYLOAD:
      return {
        ...state,
        samplePayload: action.payload.samplePayload,
      };
    case RECEIVE_CONNECTOR:
      return {...state, ...action.payload};
    case UPDATE_NODE_SCHEDULE:
      return {...state, ...action.payload};
    case RESET:
      return initialState;
    default:
      return state;
  }
}
